import moment from 'moment'
import * as Effects from 'redux-saga/effects'
import {CustomerTypeEnums} from '../../../../enums'
import {SetCustomerAddress} from '../../../../utils'
import {getCustomerById, searchAndPagingUser, step3GetObjectInsuredByIdentity} from '../apis'
import {ActionTypes, FILTERDATATABLE, USERINFORAFTERADD, USERINFORS} from './action'
import {userInitialState} from './helpers'

const call: any = Effects.call
const takeLatest = Effects.takeLatest
const put = Effects.put

export const actions = {
  addUserInfo: (data: USERINFORS) => ({type: 'ADDUSERINFORS', payload: data}),
  updateFormChangeStatus: (data: USERINFORS) => ({
    type: 'UPDATEFORMCUSTOMERCHANGESTATUS',
    payload: data,
  }),
  changeCustomereType: (change: boolean) => ({type: 'CHANGEUSERTYPE', payload: change}),
  getUserById: (id: string) => ({type: 'GETUSERBYID', payload: id}),
  getUserByIdentity: (data: any) => ({type: 'GETUSERBYIDENTITY', payload: data}),
  saveUserData: (data: any) => ({type: 'SAVEUSERDATA', payload: data}),
  getListUser: (filter: FILTERDATATABLE) => ({type: 'GETLISTUSER', payload: filter}),
  saveListUser: (data: any) => ({type: 'SAVELISTUSER', payload: data}),
  cleanUserData: (data: string) => ({type: 'CLEANUSERDATA', payload: data}),
  updateUserAfterAdd: (data: USERINFORAFTERADD) => ({type: 'UPDATEUSERAFTERADD', payload: data}),
  validateFormUser: (data: boolean) => ({type: 'VALIDATEFORMUSER', payload: data}),
}

export const userReducer = (state = userInitialState, action: ActionTypes) => {
  switch (action.type) {
    case 'ADDUSERINFORS':
      const {key, value} = action.payload
      return {
        ...state,
        [key]: value,
      }
    case 'CHANGEUSERTYPE':
      const userTypeState = JSON.parse(JSON.stringify(state))
      for (const key in userTypeState) {
        if (
          key !== 'customerType' &&
          userTypeState[key] !== null &&
          userTypeState[key] !== 0 &&
          userTypeState[key] !== '' &&
          key !== 'customerSource' &&
          key !== 'customerSegment'
        ) {
          userTypeState[key] = null
        }
      }
      return userTypeState
    case 'GETUSERBYID':
      return state
    case 'GETUSERBYIDENTITY':
      return state
    case 'SAVEUSERDATA':
      return {...state, ...action.payload}
    case 'GETLISTUSER':
      return state
    case 'SAVELISTUSER':
      const listUserState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        listUserState.dataTableUser = {
          totalRows: action.payload.totalItems,
          dataTable: [],
        }
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerType: CustomerTypeEnums.find((c) => c.value == o.customerType)?.label,
            name: o.name,
            identificationNumber: o.identificationNumber ? o.identificationNumber : o.taxNumber,
            address: '',
          }
          let address = SetCustomerAddress(o.addressName, o.subDistrict, o.district, o.province)
          obj.address = address
          listUserState.dataTableUser.dataTable.push(obj)
        })
      }
      return listUserState
    case 'CLEANUSERDATA':
      return {
        ...state,
        id: '',
        // customerType: '1',
        identificationNumber: null,
        customerCode: null,
        name: null,
        birthday: null,
        gender: null,
        addressName: null,
        province: null,
        district: null,
        subDistrict: null,
        phone: '',
        mobile: null,
        email: null,
        bank: null,
        bankNumber: null,
        customerSource: 1,
        employeeCode: null,
        parentGroupCode: null,
        customerSegment: 15,
        position: null,
        taxNumber: '',
        representative: '',
        fax: '',
        nationality: null,
        companyName: '',
        companyNameEn: '',
        contacts: null,
        customerVersion: null,
        dataTableUser: undefined,
        validateFormUser: null,
        staffCode: null,
        aliasName: null,
        shortName: null,
        isChangeData: null,
      }
    case 'UPDATEUSERAFTERADD':
      return {
        ...state,
        customerCode: action.payload.customerCode,
        customerVersion: action.payload.customerVersion,
      }
    case 'VALIDATEFORMUSER':
      return {...state, validateFormUser: action.payload}
    case 'UPDATEFORMCUSTOMERCHANGESTATUS':
      return {...state, isChangeData: action.payload.value}
    default:
      return state
  }
}

export function* saga() {
  yield takeLatest('GETUSERBYID', function* getUserByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(getCustomerById, action.payload)
      if (response && !response.isError) {
        response.data.birthday = moment(response.data.birthday, 'DD/MM/YYYY').format('YYYY/MM/DD')
        yield put(actions.saveUserData(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETUSERBYIDENTITY', function* ggetUserByIdentitySaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredByIdentity, action.payload)
      if (response && !response.isError) {
        response.data.objectInsuredInfo.birthday = moment(
          response.data.objectInsuredInfo.birthday,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        response.data.objectInsuredInfo.customerVersion = response.data.objectInsuredInfo.version
        yield put(actions.saveUserData(response.data.objectInsuredInfo))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETLISTUSER', function* getListUserSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingUser, action.payload)
      if (response && !response.isError) {
        yield put(actions.saveListUser(response.data))
      }
    } catch (error) {
      return
    }
  })
}
